import { computed, ref } from 'vue'

export default {
    name: 'TooltipComponent',
    props: {
        tooltipText: {
            type: String,
            required: true
        },
        tooltipName: {
            type: String,
            required: true
        }
    },
    setup(props) {
        let display = ref(false)

        const tooltipAccessibleName = computed(() => {
            return props.tooltipName ?? ''
        })

        const setESChandler = () => {
            const handler = (event) => {
                if (event.key === 'Escape') {
                    closeDialog()
                    document.body.removeEventListener('keydown', handler)
                }
            }
            document.body.addEventListener('keydown', handler)
        }

        const highlighted = ref(null)
        const wordPopup = ref(null)
        const arrow = ref(null)
        const closeButton = ref(null)

        const clickOutsideHandler = function (e) {
            if (wordPopup.value.contains(e.target)) return false
            e.preventDefault()
            closeDialog()
        }

        const tapTrap = (e) => {
            e.preventDefault()
            e.stopPropagation()
            closeDialog()
            highlighted.value.focus()
        }

        const showDialog = () => {
            setESChandler()

            display.value = true

            // we need to make sure the DOM has catched up and the popup element is present before we start to measure positions
            // wordPopup and arrow might be empty if we dont apply this slight wait
            setTimeout(() => {
                // original positions before calculations

                let arrowPosition = 0
                const currentLeftPosition =
                    wordPopup.value.getBoundingClientRect().left
                const currentRightPosition =
                    wordPopup.value.getBoundingClientRect().right
                const currentBottomPosition =
                    wordPopup.value.getBoundingClientRect().bottom

                const popupWidth = wordPopup.value.offsetWidth
                const highlightedWidthCompensation =
                    highlighted.value.offsetWidth / 2 - 10
                let calculatedLeftPosition =
                    popupWidth / 2 - highlightedWidthCompensation

                const exceedsBottomEdge =
                    currentBottomPosition >
                    document.documentElement.clientHeight
                const exceedsLeftEdge =
                    calculatedLeftPosition > currentLeftPosition
                const exceedsRightEdge =
                    currentRightPosition - calculatedLeftPosition >
                    document.documentElement.offsetWidth

                if (exceedsBottomEdge) {
                    wordPopup.value.style.bottom =
                        highlighted.value.offsetHeight + 10 + 'px'
                    arrow.value.style.bottom = '-10px' // specific value matching the actual height of the rotated square being used (do not change)
                    arrow.value.style.top = 'auto' // a reset to hardcounter styling
                }

                if (exceedsLeftEdge) {
                    calculatedLeftPosition =
                        calculatedLeftPosition -
                        (calculatedLeftPosition - currentLeftPosition)
                    arrowPosition =
                        highlighted.value.offsetWidth / 2 -
                        10 +
                        highlighted.value.getBoundingClientRect().left
                } else if (exceedsRightEdge) {
                    const calculatedRightPosition =
                        currentRightPosition -
                        calculatedLeftPosition -
                        document.documentElement.offsetWidth
                    calculatedLeftPosition =
                        calculatedLeftPosition + calculatedRightPosition
                    arrowPosition = popupWidth / 2 + calculatedRightPosition
                }

                wordPopup.value.style.left = '-' + calculatedLeftPosition + 'px'

                if (arrowPosition) {
                    arrow.value.style.left = arrowPosition + 'px'
                }

                document.body.addEventListener('click', clickOutsideHandler)

                closeButton.value.focus()
            }, 10)
        }

        const closeDialog = () => {
            document.body.removeEventListener('click', clickOutsideHandler)
            display.value = false
        }

        return {
            arrow,
            closeDialog,
            closeButton,
            display,
            highlighted,
            showDialog,
            tapTrap,
            wordPopup,
            tooltipAccessibleName
        }
    }
}
